module.exports = __webpack_public_path__ + "static/img/name_white.18a353e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/name_white.png
// module id = f31O
// module chunks = 18